<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    :persistent="loading"
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn small v-on="on" v-bind="attrs" :disabled="disabled">
        <v-icon>
          mdi-delete
        </v-icon>
      </v-btn>
    </template>

    <v-toolbar dense>
      <v-toolbar-title>
        <span>
          {{ $t("freespins.removingFreespin") }}
        </span>
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-btn icon @click="closeDialog" :disabled="loading">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card>
      <v-card-text class="pa-4">
        <div v-if="freespin.campaign_type !== 'personalizado'">
          <span>{{ $t("freespins.titleWhatYouWannaDo") }}</span>

          <v-radio-group v-model="selectedRemoveAdhesions">
            <v-radio
              value="2"
              :label="$t('freespins.cancelPromotionAndFreespinsAdhered')"
            ></v-radio>
            <v-radio
              value="1"
              :label="$t('freespins.cancelFreespinsAdhered')"
            ></v-radio>
          </v-radio-group>
        </div>

        <v-alert
          border="left"
          colored-border
          type="info"
          color="#B50000"
          elevation="2"
        >
          <span style="font-size: 12px; font-weight: 400;">
            {{ $t("freespins.removeAlert") }}
          </span>
        </v-alert>

        <div
          v-html="
            $t('freespins.deleteFreespinAlert', {
              title: freespin.title,
            })
          "
        ></div>
      </v-card-text>

      <v-card-actions class="pr-4 pb-4">
        <v-spacer />
        <v-btn
          class="white black--text"
          @click="closeDialog"
          outlined
          small
          :disabled="loading"
        >
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn
          @click="confirm"
          color="#B50000"
          small
          :loading="loading"
          :disabled="
            loading ||
            (freespin.campaign_type !== 'personalizado' &&
              !selectedRemoveAdhesions)
          "
        >
          {{ $t("toConfirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    freespin: {
      type: Object,
    },
  },

  data: () => ({
    dialog: false,
    loading: false,
    selectedRemoveAdhesions: 0, // (0 - Selecionar nenhuma opção | 1 - Não remover aderidos | 2 - Remover aderidos)
  }),

  computed: {
    disabled() {
      return this.freespin && this.freespin.status != 1;
    },
  },

  methods: {
    confirm() {
      if (this.disabled) {
        return;
      }

      this.loading = true;

      if (this.freespin.campaign_type == "personalizado")
        this.selectedRemoveAdhesions = 2;

      const body = {
        campaign_freespins_id: this.freespin.campaign_id,
        remove_adhesions: this.selectedRemoveAdhesions == 2 ? "1" : "0",
      };

      this.$axios
        .post(
          `${this.$prefix()}/cassino/gamesAgregation/removeFreespinsCampaign`,
          this.$formdata(body)
        )
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });

          this.$emit("removeFreespin", this.freespin.campaign_id);
        })
        .finally(() => {
          this.loading = false;
          this.closeDialog();
        });
    },
    closeDialog() {
      this.dialog = false;
      this.selectedRemoveAdhesions = "";
    },
  },
};
</script>
